export function setOffMarketPropertyId(id: string) {
  window.postMessage(
    {
      eventName: 'off_market_property_show',
      payload: { id }
    }
  );
}

export function setExclusiveListingId(id: number) {
  window.postMessage(
    {
      eventName: 'exclusive_listing_show',
      payload: { id }
    }
  );
}
